import React, { ReactNode } from 'react';
import { View, Platform, useWindowDimensions } from 'react-native';
import { responsiveStyle } from '../../services/utils';
import { BackButton } from '../atomic/BackButton';
import { ResponsiveView } from './ResponsiveView';
import { ResponsiveRow } from './ResponsiveRow';
import { ResponsiveColumn } from './ResponsiveColumn';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { ContributionType } from '../../types';
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';
import { ContributionPhotoList } from '../molecules/ContributionPhotoList';
import { ContributionMedia } from '../../entities/ContributionMedia';
import { MActuPostMedia } from '../../entities/MActuPostMedia';
import { useDeviceSize } from '../../hooks/useDeviceSize';

export function ContentWithImageHeaderScreen(props: {
  contribution:
    | {
        contribution: {
          contributionMedias: ContributionMedia[];
        };
      }
    | {
        contributionMedias: ContributionMedia[];
      }
    | {
        mActuPostMedias: MActuPostMedia[];
      };
  contributionType: ContributionType;
  imageContentOverride?: ReactNode;
  bottomContent?: ReactNode;
  underImageContent?: ReactNode;
  children: ReactNode;
  navigation: any;
  absoluteBackNavigation?: string;
  absoluteBackNavigationDetail?: any;
}) {
  const screenDimensions = useWindowDimensions();
  const { isSmallDevice } = useDeviceSize();

  return (
    <SafeAreaProvider>
      <SafeAreaView edges={['top']} style={{ flex: 1 }}>
        <KeyboardAwareScrollView
          bounces={false}
          style={{
            flex: 1,
            flexDirection: 'column',
            // justifyContent: 'center',
          }}
          scrollEventThrottle={1}
          contentContainerStyle={{ paddingBottom: 20 }}
          showsVerticalScrollIndicator={Platform.OS === 'ios' ? false : true}
        >
          <ResponsiveRow breakpoint={3000}>
            <ResponsiveColumn first={true} bigScreenStyle={{ display: 'flex', alignItems: 'center' }}>
              {props.imageContentOverride ? (
                <View
                  style={responsiveStyle(
                    {
                      height: 300,
                    },
                    {
                      height: 500,
                      marginTop: 10,
                      marginLeft: 10,
                    }
                  )}
                >
                  {props.imageContentOverride}
                </View>
              ) : (
                <ContributionPhotoList
                  photos={
                    (props.contribution as any)?.mActuPostMedias ||
                    (props.contribution as any)?.contributionMedias ||
                    (props.contribution as any)?.contribution?.contributionMedias ||
                    []
                  }
                  mode="parallax"
                  width={isSmallDevice ? screenDimensions.width : 540}
                  height={isSmallDevice ? screenDimensions.width - 50 : 540}
                  noBorderRadius={isSmallDevice}
                  buttonsPosition={isSmallDevice ? 'inside' : 'far'}
                  contributionType={props.contributionType}
                  displayImageNumber
                />
              )}
              {props.underImageContent}
            </ResponsiveColumn>
            <ResponsiveView bigScreenStyle={{ marginTop: 0 }}>{props.children}</ResponsiveView>
          </ResponsiveRow>
          {props.bottomContent}
        </KeyboardAwareScrollView>
        <BackButton
          absoluteScreenName={props.absoluteBackNavigation}
          navigationDetails={props.absoluteBackNavigationDetail}
        />
      </SafeAreaView>
    </SafeAreaProvider>
  );
}
